import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';

const CallButton = ({ content }) => {
    const wxLaunchHackData = {
        callAppConfig: {
            docType: 'web',
            pid: 'https://client.ifeng.com/loc/japanvote2026?isFull=0&immersion=true&ifengsp=1&needpage=1&needpage=1',
            kind: 'inter_rbxj01',
            noKindFrom: 1,
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7370173848793531392',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9231',
        },
        statisticsConfig: {
            behavior: 'action',
            type: 'japanvote2026',
        },
    };

    const isMobile = navigator.userAgent.toLowerCase().includes('mobile');
    // const is

    return (
        !window.grounds && (
            <div className={styles.callButtonBox}>
                {isMobile ? (
                    <div className={styles.callButton}>
                        打开凤凰新闻 观看更多选举报道
                        <WxLaunchHack content={wxLaunchHackData} />
                    </div>
                ) : (
                    <div className={styles.qrCode}>
                        <img className={styles.qrCodePic} src="https://qrcode.ifeng.com/2026/02/07/da03f70385655a4218be118e754fdf8f.png" />
                        <div className={styles.qrCodeText}>扫码打开凤凰新闻客户端 观看更多选举报道</div>
                    </div>
                )}
            </div>
        )
    );
};

CallButton.propTypes = {
    content: PropTypes.object,
};

export default CallButton;
